import { CarnivalTreasureResult } from '@/models/games/carnivalTreasure';
import {
    convertDetailResultString,
    getMultiplierByMultiplierIndex,
} from '@/utils/games/carnivalTreasure';
import { useMemo } from 'react';
import { GameResultCellProps } from '..';
import { RResultCell } from '@/modules/rwdGame/carnivalTreasure/RecordHistory/RResultCell';

//Game Result Cell
// type GRCellProps = {
//     result: string;
// };
// const GRCell = (props: GRCellProps) => {
//     let child: JSX.Element | undefined = undefined;
//     switch (props.result) {
//         case '2X':
//             child = <BetlogCT2X />;
//             break;
//         case '10X':
//             child = <BetlogCT10X />;
//             break;
//         default:
//             child = undefined;
//     }

//     return (
//         <div
//             className={`carnival-treasure-result-cell item-${props.result.toLowerCase()}`}
//         >
//             {child ? (
//                 <div className={'carnival-treasure-multiplier-cell'}>
//                     {child}
//                 </div>
//             ) : (
//                 props.result
//             )}
//         </div>
//     );
// };

//Main game result
// const svgText: { [key: string]: JSX.Element } = {
//     //Promotion
//     '0': <MultiplierCT0 className="ct-mul-svg-text" />,
//     '1': <MultiplierCT1 className="ct-mul-svg-text" />,
//     '2': <MultiplierCT2 className="ct-mul-svg-text" />,
//     '3': <MultiplierCT3 className="ct-mul-svg-text" />,
//     '4': <MultiplierCT4 className="ct-mul-svg-text" />,
//     '5': <MultiplierCT5 className="ct-mul-svg-text" />,
//     '6': <MultiplierCT6 className="ct-mul-svg-text" />,
//     '7': <MultiplierCT7 className="ct-mul-svg-text" />,
//     '8': <MultiplierCT8 className="ct-mul-svg-text" />,
//     '9': <MultiplierCT9 className="ct-mul-svg-text" />,
//     ',': <MultiplierCTComma className="ct-mul-svg-text" />,
//     X: <MultiplierCTX className="ct-mul-svg-text" />,
// };

type MainProps = {
    result: number;
    multiplierSize: number;
    payout: string;
};
const MainResult = (props: MainProps) => {
    const { result, payout, multiplierSize } = props;
    // const payoutText = useMemo(() => numberFormat(Number(payout), 0), []);
    return (
        <>
            {result && (
                <div className="carnival-treasure-bet-result-wrapper">
                    <RResultCell
                        resultPoint={result.toString()}
                        multiples={multiplierSize > 0}
                        payout={Number(payout)}
                    />
                    {/* <GRCell result={result.toString()} />
                    {multiplierSize > 0 && (
                        <>
                            <div className="multiplier-border" />
                            <div className="payout-svg-text-wrapper">
                                <div className="payout-svg-text">
                                    {payoutText.split('').map((item, index) => (
                                        // Add a Fragment with a unique key as the wrapper
                                        <React.Fragment
                                            key={`${item}-${index}`}
                                        >
                                            {svgText[item]}
                                        </React.Fragment>
                                    ))}
                                    {svgText['X']}
                                </div>
                            </div>
                        </>
                    )} */}
                </div>
            )}
        </>
    );
};

//Details
type DetailsProps = {
    result: number;
    multipliers: number[];
};
const Details = (props: DetailsProps) => {
    const { result, multipliers } = props;
    const items = useMemo(() => {
        const targetList: string[] = [];
        for (let i = 0; i < multipliers.length; i++) {
            targetList.push(
                `${getMultiplierByMultiplierIndex(multipliers[i])}X`
            );
        }
        targetList.push(result.toString());

        return targetList;
    }, [result, multipliers]);

    return (
        <div className="carnival-treasure-detail-result-wrapper">
            <div className="detail-result">
                {items.map((item, i) => {
                    // return <GRCell key={`cell_${i}`} result={item} />;
                    return (
                        <div
                            key={`cell_${i}`}
                            className="carnival-treasure-result-cell"
                        >
                            <RResultCell resultPoint={item.toLowerCase()} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export const CarnivalTreasureGameResult = (props: GameResultCellProps) => {
    const { summary, expanded } = props;
    const ctResult = useMemo(
        () =>
            convertDetailResultString(summary.Result) as CarnivalTreasureResult,
        [summary]
    );

    return (
        <>
            <div className="item-carnival-treasure-game-result-container">
                <MainResult
                    result={ctResult.ResultPoint}
                    multiplierSize={ctResult.MultiplierSize}
                    payout={ctResult.PayoutFinal}
                />
                <div className="place-holder" />
                {expanded && (
                    <Details
                        result={ctResult.ResultPoint}
                        multipliers={ctResult.Multipliters}
                    />
                )}
            </div>
        </>
    );
};
